import styled from 'styled-components';

const Signal = styled.div`
  display: flex;
  align-items: flex-end;
`;

export default Signal;
